export default {
	'Are you sure you want to restore all configurations to the default values?': 'Are you sure to restore all configurations to the default values?',
	'Background color when hovering over the top bar': 'Top bar hover background color',
	'Background page switching animation': 'Background page switching animation',
	classic: 'Classic',
	'Dark mode': 'Dark mode',
	default: 'Default',
	'Double column': 'Double column',
	'Exit full screen': 'Exit Full Screen',
	'Full screen is not supported': 'Your browser does not support full screen, please change another browser and try again~',
	'Layout configuration': 'Layout configuration',
	'Layout mode': 'Layout mode',
	Login: 'Login',
	'Login to the buildadmin': 'Login to the buildadmin',
	Logout: 'Logout',
	'Member center': 'Member center',
	'Member information': 'Member information',
	'overall situation': 'Global',
	Password: 'Password',
	'Please enter buildadmin account name or email': 'Please enter buildadmin account name or email',
	'Please enter the buildadmin account password': 'Please enter the buildadmin account password',
	'Please select an animation name': 'Please select an animation name',
	Profile: 'Profile',
	Register: 'Register',
	'Restore default': 'Restore default',
	'Show side menu top bar (logo bar)': 'Display the top bar of the side menu (Logo Bar)',
	'Side menu accordion': 'Side menu accordion',
	'Side menu active item background color': 'Background color of the side menu activation item',
	'Side menu active item text color': 'Side menu activation item text color',
	'Side menu bar background color': 'Background color of the side menu bar',
	'Side menu default icon': 'Side menu default icon',
	'Side menu horizontal collapse': 'Side menu collapsed horizontally',
	'Side menu text color': 'Side menu text color',
	'Side menu top bar background color': 'Background color of the top bar of the side menu ',
	'Side menu width (when expanded)': 'Width of the side menu (Unfolding)',
	sidebar: 'Sidebar',
	'Single column': 'Single Column',
	'Top bar': 'Top bar',
	'Top bar background color': 'Top bar background color',
	'Top bar menu active item background color': 'Background color of the top bar activation item',
	'Top bar menu active item text color': 'Top bar menu activation item text color',
	'Top bar text color': 'Top bar text color',
	Username: 'Username',
}
